// extracted by mini-css-extract-plugin
module.exports = {"root":"AddAttribute_root__3jK0U","addAttributeForm":"AddAttribute_addAttributeForm__3qnbO","inputs":"AddAttribute_inputs__S_r8X"};